export const validateManualCommonAddress = (
  declarationRequest,
  validateRequired,
  setError,
  setValidFields,
  isMain = false,
) => {
  let isManualValid = true;

  // manual_governorate_id
  if (!validateRequired(declarationRequest?.unit?.manual_governorate_id)) {
    setValidFields((prev) => ({ ...prev, manual_governorate_id: false }));
    setError("manual_governorate_id", "يجب إختيار المحافظة");
    isManualValid = false;
  } else {
    setError("manual_governorate_id", "");
    setValidFields((prev) => ({ ...prev, manual_governorate_id: true }));
  }

  // manual_policestation_id
  if (!validateRequired(declarationRequest?.unit?.manual_policestation_id)) {
    setValidFields((prev) => ({ ...prev, manual_policestation_id: false }));
    setError("manual_policestation_id", "يجب إختيار قسم/مركز الشرطة");
    isManualValid = false;
  } else {
    setError("manual_policestation_id", "");
    setValidFields((prev) => ({ ...prev, manual_policestation_id: true }));
  }

  if (isMain) {
    // manual_known_build_num
    if (!validateRequired(declarationRequest?.unit?.manual_known_build_num)) {
      setValidFields((prev) => ({ ...prev, manual_known_build_num: false }));
      setError(
        "manual_known_build_num",
        "يجب إدخال رقم العقار/المبنى كما هو متعارف عليه",
      );
      isManualValid = false;
    } else {
      setError("manual_known_build_num", "");
      setValidFields((prev) => ({ ...prev, manual_known_build_num: true }));
    }
  } else {
    if (
      !validateRequired(
        declarationRequest?.unit?.building?.building_manual_known_build_num,
      )
    ) {
      setValidFields((prev) => ({
        ...prev,
        building_manual_known_build_num: false,
      }));
      setError(
        "building_manual_known_build_num",
        "يجب إدخال رقم العقار/المبنى كما هو متعارف عليه",
      );
      isManualValid = false;
    } else {
      setError("building_manual_known_build_num", "");
      setValidFields((prev) => ({ ...prev, manual_known_build_num: true }));
    }
  }

  return isManualValid;
};

export const validateManualBuildingMatch = (declarationRequest, building) => {
  if (building?.main_building !== 1) {
    const unitGov = parseInt(declarationRequest?.unit?.manual_governorate_id);
    const buildingGov = parseInt(
      declarationRequest?.unit?.building?.manual_governorate_id,
    );

    const unitPolice = parseInt(
      declarationRequest?.unit?.manual_policestation_id,
    );
    const buildingPolice = parseInt(
      declarationRequest?.unit?.building?.manual_policestation_id,
    );

    const isGovMatching = unitGov === buildingGov;
    const isPoliceMatching = unitPolice === buildingPolice;

    return isGovMatching && isPoliceMatching;
  } else {
    return true;
  }
};

export const validateBuildingFilterSearchType = (
  declarationRequest,
  currentType,
) => {
  const buildings = declarationRequest?.unit?.buildings || [];

  for (const b of buildings) {
    const type = parseInt(b?.filter_search_type);

    // Case: if currentType is 1 or 2, then type must also be 1 or 2
    if (parseInt(currentType) === 1 || parseInt(currentType) === 2) {
      if (!(parseInt(type) === 1 || parseInt(type) === 2)) {
        return false;
      }
    } else {
      // Case: for any other type (e.g. 3), must match exactly
      if (parseInt(type) !== parseInt(currentType)) {
        return false;
      }
    }
  }

  return true;
};

export const getFilterSearchTypes = (declarationRequest) => {
  const buildings = declarationRequest?.unit?.buildings || [];

  const types = buildings?.map((b) => parseInt(b.filter_search_type));

  if (types?.includes(3)) {
    return 3;
  }

  if (types?.some((t) => t === 1 || t === 2)) {
    return 1;
  }

  return null;
};

export const hasFilterSearchTypeMismatch = (declarationRequest) => {
  const buildings = declarationRequest?.unit?.buildings || [];
  const unitType = parseInt(declarationRequest?.unit?.filter_search_type_id);

  // collect all building filter_search_type values
  const types = buildings.map((b) => parseInt(b.filter_search_type));

  // Rule 1: if any building type is 1 or 2 AND unitType is 1 or 2 → false
  if (
    types.some((t) => t === 1 || t === 2) &&
    (unitType === 1 || unitType === 2)
  ) {
    return false;
  }

  // Rule 2: if any building type is 3 AND unitType is 1 or 2 → true
  if (types.includes(3) && (unitType === 1 || unitType === 2)) {
    return true;
  }

  // Rule 3: if any building type is 1 or 2 AND unitType is 3 → true
  if (types.some((t) => t === 1 || t === 2) && unitType === 3) {
    return true;
  }

  // fallback: no match
  return false;
};

export const getMatchingBuildings = (declarationRequest) => {
  const buildings = declarationRequest?.unit?.buildings || [];
  const filterType = parseInt(declarationRequest?.unit?.filter_search_type_id);

  return buildings?.filter(
    (b) => parseInt(b?.filter_search_type) === filterType,
  );
};

export const getMatchingHotelUnits = (declarationRequest) => {
  const hotelUnits = declarationRequest?.unit?.hotelUnits || [];
  // const filterType = parseInt(declarationRequest?.unit?.filter_search_type_id);

  return hotelUnits;
};
